import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://nbdkpnrohpqqqqqnmhit.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5iZGtwbnJvaHBxcXFxcW5taGl0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUxMDQ3MTUsImV4cCI6MjA3MDY4MDcxNX0.M-9nUYL87oSOuFupj9D688QvcDb_GVdhhVTwELqXI7g';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);